export function transformStoreDrillData(edges = []) {
	return edges.map((edge) => {
		const node = edge?.node;
		if (!node) {
			return {}; // Return an empty object if node is undefined or null
		}
		const dimensions = node?.dimensions || {};
		const sales = node?.sales || {};
		const inventory = node?.inventory || {};
		const opd = node?.opd || {};
		return {
			...inventory,
			...sales,
			...dimensions,
			nbr: dimensions.dc?.nbr || '',
			nm: dimensions.dc?.nm || '',
			...opd,
		};
	});
}
